<div
  [attr.aria-label]="getAriaLabel"
  [attr.aria-valuemax]="100"
  [attr.aria-valuemin]="0"
  [attr.aria-valuenow]="getBarPercentile"
  [attr.aria-valuetext]="getAriaValueText"
  id="loading-bar-container"
  role="progressbar">

  <div
    [ngClass]="{
      'bar-border': isBorderVisible,
      'bar-small': barSize === 'small',
      'bar-medium': barSize === 'medium',
      'bar-large': barSize === 'large',
      'bar-error': getIsError,
      'bar-success': !getIsError,
    }"
    class="bar">
    <div class="incomplete"></div>
    <div [style.width.%]="getBarPercentile" class="complete">
      <div class="text-container">
        <div class="text">{{ getDisplayText }}</div>
        <span></span>
        <div class="text">{{ getDisplayPercentile }}</div>
      </div>
    </div>
  </div>

</div>

